import { ReactLenis } from "lenis/react";
import "@/App.css";
import { Preloader } from "@/components/landing/Preloader";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { Experience } from "@/components/landing/Experience";
import { Marquee } from "@/components/landing/Marquee";
import { Itinerary } from "@/components/landing/Itinerary";
import { Gallery } from "@/components/landing/Gallery";
import { Testimonials } from "@/components/landing/Testimonials";
import { Countdown } from "@/components/landing/Countdown";
import { Pricing } from "@/components/landing/Pricing";
import { Footer } from "@/components/landing/Footer";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <div className="App relative bg-ink text-[var(--paper)]">
        {/* Fixed film grain overlay */}
        <div className="grain pointer-events-none fixed inset-0 z-[80] opacity-[0.035] mix-blend-overlay" aria-hidden="true" />

        <Preloader />
        <Header />
        <main>
          <Hero />
          <Experience />
          <Marquee />
          <Itinerary />
          <Gallery />
          <Testimonials />
          <Countdown />
          <Pricing />
        </main>
        <Footer />
      </div>
    </ReactLenis>
  );
}

export default App;
